@if (showAlertRefazerRota) {
  <app-alert-refazer-rota [dadosRoteirizacao]="detalheRoteirizacao" [idUsuario]="idUsuario" (alertRefazerRotaFechou)="eventoAlertRefazerRota($event)"></app-alert-refazer-rota>
}
@if (showAlertSucessoAprovacao) {
  <app-alert-sucesso-aprovacao (alertSucessoAprovacao)="eventoAlertSucessoAprovacaoFechou($event)"></app-alert-sucesso-aprovacao>
}
@if (alertPergunta) {
  <app-alert-pergunta (alertPerguntaFechou)="eventoAlertPergunta($event)"></app-alert-pergunta>
}
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Rota Inteligente
          <button
            class="btn-icon"
            (click)="goBackPage()"
            aria-label="Voltar página">
            <i class="fa fa-arrow-left botao-setinha-voltar" aria-hidden="true"></i>
          </button>
        </h1>
        <p class="paragrafo mb-4">Roteirizações realizadas</p>

        <div class="row">

          <div class="col-12">
            <!-- TABELA -->
            @if (dadosRotaInteligente) {
              <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista dados da rota inteligente">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">DATA</th>
                    <th scope="col">ENDEREÇO DE TRABALHO</th>
                    <th scope="col">ENDEREÇO DE RESIDÊNCIA</th>
                    <th scope="col">ACEITE</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- LINHA 1 -->
                  <!-- AQUI VAI O NGFOR DOS DADOS -->
                  @for (rota of dadosRotaInteligente; track rota) {
                    <tr>
                      <td>
                        <button
                          class="btn-icon p-0 border-0 bg-transparent"
                          (click)="consultaDadosRoteirizacao(rota.idRoteirizacao)"
                          data-bs-toggle="tooltip"
                          data-placement="top"
                          title="Clique para detalhar"
                          aria-label="Clique para detalhar">
                          <i class="fa fa-plus-circle icone" aria-hidden="true"></i>
                        </button>
                      </td>
                      <td>{{rota.data | appDate: 'dd/MM/yyyy'}}</td>
                      <td>{{rota.enderecoTrabalho}}</td>
                      <td>{{rota.enderecoResidencia}}</td>
                      @if (rota.aceite === 'S') {
                        <td>Sim</td>
                      }
                      @if (rota.aceite === 'N') {
                        <td>Não</td>
                      }
                      <td>{{rota.status}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }

            @if (mensagemErroRotaInteligente) {
              <div class="row mt-4 mb-0">
                <p class="legenda-erro mensagem-erro">{{mensagemErroRotaInteligente}}</p>
              </div>
            }

            @if (dadosRotaInteligente) {
              <div class="w-100 text-center">
                <button class="botao-outline px-5 mt-5 mb-4 mx-auto botao-ajuste" (click)="clickRefazerRota()">REFAZER ROTA INTELIGENTE</button>
              </div>
            }

            @if (dadosRotaInteligente === null) {
              <div>
                <div class="text-center">
                  <output class="spinner-border c-primary">
                    <span class="visually-hidden">Consultando rota inteligente ...</span>
                  </output>
                </div>
                <p class="legenda-spinner">Consultando rota inteligente ...</p>
              </div>
            }

            @if (dadosRotaInteligente === false) {
              <div class="text-center">
                <img src="/assets/img/erro.png" width="230px" alt="Erro">
                <p class="legenda-erro">Ocorreu um erro na consulta da rota inteligente.</p>
              </div>
            }

            @if (dadosRotaInteligente === undefined) {
              <div class="text-center">
                <img src="/assets/img/vazio.png" width="230px" alt="usuario nao possui rota">
                <p class="legenda-vazio">Esse usuário ainda não possui rota inteligente.</p>
              </div>
            }
          </div>


        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
